import { useState } from 'react'
import {
    flexRender,
    getCoreRowModel,
    useReactTable,
    Table,
    getFilteredRowModel,
    getSortedRowModel,
    SortingState,
    getPaginationRowModel
} from '@tanstack/react-table'

function DateTableSimples(props: any) {

    document.body.onmousedown = function (e) { if (e.button === 1) return false; }

    const [searching, setSearching] = useState<string>('')
    const [sorting, setSorting] = useState<SortingState>(props.defaultOrder)
    const [columns] = useState<typeof props.defaultColumns>(() => [...props.defaultColumns])

    let table: Table<any> = useReactTable({
        data: props.dados,
        columns: columns,
        columnResizeMode: 'onChange',
        getSortedRowModel: getSortedRowModel(),
        getCoreRowModel: getCoreRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
        getPaginationRowModel: getPaginationRowModel(),
        onGlobalFilterChange: setSearching,
        onSortingChange: setSorting,
        state: {
            globalFilter: searching,
            sorting: sorting,
            // pagination: {
            //     pageIndex: 0,
            //     pageSize: pageSize
            // }
        },
    })

    function handleRowMiddleClick(event: any) {
        event.preventDefault()
        event.stopPropagation()
        props.tableMiddleClickhandler(event)
    }

    function handleRowClick(event: any) {
        props.tableClickhandler(event)
    }

    return (
        <div>
            <div className='divDataTable' style={{ direction: table.options.columnResizeDirection }}>

                <table
                    {...{
                        style: props.tableSize === 'fixed' ? {
                            width: table.getCenterTotalSize(),
                        } : {
                            width: "100%",
                            display: "table",
                            tableLayout: "auto"
                        },
                        className: 'dataTable'
                    }}
                >
                    <thead>
                        {table.getHeaderGroups().map(headerGroup => (
                            <tr key={headerGroup.id}>
                                {headerGroup.headers.map(header => (
                                    <th
                                        {...{
                                            key: header.id,
                                            colSpan: header.colSpan,
                                            style: {
                                                width: header.getSize(),
                                            },
                                        }}
                                    >
                                        {header.isPlaceholder
                                            ? null
                                            : (
                                                <div
                                                    {...{
                                                        className: header.column.getCanSort()
                                                            ? 'cursor-pointer select-none'
                                                            : '',
                                                        onClick: header.column.getToggleSortingHandler(),
                                                    }}
                                                >
                                                    {flexRender(
                                                        header.column.columnDef.header,
                                                        header.getContext()
                                                    )}
                                                    {{
                                                        asc: ' 🔽',
                                                        desc: ' 🔼',
                                                    }[header.column.getIsSorted() as string] ?? null}
                                                </div>
                                            )
                                        }
                                        <div
                                            {...{
                                                onDoubleClick: () => header.column.resetSize(),
                                                onMouseDown: header.getResizeHandler(),
                                                onTouchStart: header.getResizeHandler(),
                                                className: `resizer ${table.options.columnResizeDirection
                                                    } ${header.column.getIsResizing() ? 'isResizing' : ''
                                                    }`,
                                            }}
                                        />
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>
                    <tbody>
                        {table.getRowModel().rows.map(row => (
                            <tr key={row.id} onAuxClick={handleRowMiddleClick} onMouseDown={handleRowClick} about={String(row.index)} style={{ height: '32px' }}>
                                {row.getVisibleCells().map(cell => (
                                    <td
                                        {...{
                                            key: cell.id,
                                            style: {
                                                width: cell.column.getSize(),
                                            },
                                        }}
                                    >
                                        {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                    </td>
                                ))}
                            </tr>
                            // </a>
                        ))}
                    </tbody>
                    <tfoot style={{fontWeight: "bold"}}>
                        <tr>
                            <td>Total</td>
                            <td>{props.dadosTotais.qtd}</td>
                            <td>{props.dadosTotais.valor}</td>
                            <td>{props.dadosTotais.porcentagem}</td>
                        </tr>
                    </tfoot>
                </table>

            </div>
        </div>
    )

}

export default DateTableSimples